module.exports = __webpack_public_path__ + "img/未购买包年图源.0ee8c732.png";